import { scrollToSectionId } from "./scrollToSection";

/**
 * Navegação por âncora compatível com React Router (SPA).
 */
export function navigateToSection(navigate, location, sectionId) {
  const targetHash = `#${sectionId}`;
  if (location.pathname !== "/") {
    navigate({ pathname: "/", hash: sectionId });
    return;
  }
  if (location.hash === targetHash) {
    scrollToSectionId(sectionId);
  } else {
    navigate({ pathname: "/", hash: sectionId }, { replace: true });
  }
}

/** href no formato "/#id" — retorna o id ou null */
export function parseHashSectionHref(href) {
  if (!href || typeof href !== "string") return null;
  if (!href.startsWith("/#")) return null;
  const id = href.slice(2);
  return id || null;
}
